import React from 'react'
import { Container, Row, Col, Card, Image } from "react-bootstrap"

//image
import error2 from '../../../assets/images/error/02.png'

const Maintenance = () => {
    return (
        <>
            <div className="wrapper">
                <div className="mt-5 iq-maintenance">
                    <Container fluid>
                        <Row className="no-gutters">
                            <Col sm="12" className="text-center">
                                <div className="iq-maintenance">
                                    <Image src={error2} className="img-fluid w-50" alt=""/>
                                    <h3 className="mt-4 mb-1 text-center">We are Currently Performing Maintenance</h3>
                                    <p className="text-center">Please check back in sometime.</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Maintenance;
